import * as React from 'react'

export interface AutoScrollableProps {
  onClick?: () => void
  onMouseOut?: () => void
  onMouseOver?: () => void
  shouldScroll?: boolean
  shouldRescroll?: boolean
  behavior?: ScrollBehavior
  block?: 'start' | 'center' | 'nearest' | 'end' | undefined
  inline?: 'start' | 'center' | 'nearest' | 'end' | undefined
}

export function withAutoScrollable<P extends object>(
  Wrapped: React.ComponentType<P & any>
) {
  return class AutoScrollable extends React.PureComponent<P & AutoScrollableProps> {
    private scrollable = React.createRef<HTMLSpanElement>()

    public scrollIntoFocus = () => {
      const node = this.scrollable.current as HTMLDivElement
      const { behavior, block, inline } = this.props

      const options: ScrollIntoViewOptions = {
        behavior: behavior || 'smooth',
        block: block || 'center',
        inline: inline || 'nearest',
      }

      node.scrollIntoView(options)
    }

    public componentDidMount() {
      if (this.props.shouldScroll) {
        this.scrollIntoFocus()
      }
    }

    public componentDidUpdate(prevProps: AutoScrollableProps) {
      if (!prevProps.shouldRescroll && this.props.shouldRescroll) {
        this.scrollIntoFocus()
      }
    }

    public render() {
      return (
        <React.Fragment>
          <span ref={this.scrollable}>
            <Wrapped {...this.props}>{this.props.children}</Wrapped>
          </span>
        </React.Fragment>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/base/AutoScrollable/index.tsx